import templateUrl from './reports-page-template.html';

export const reportsPageTemplateComponent = {
	templateUrl,

	bindings: {
		details: '<',
		title: '@',
		displayTitle: '@',
		displayDropdown: '@',
		displayImage: '@',
		onProgramYearChange: '&',
		buttonText: '@',
		selectedId: '<',
		paginationDetails: '<',
		onPageChange: '&',
		isPaginationEnabled: '@',
		featureHeading: '@',
		isArchiveOptionEnabled: '@',
		onClickArchive: '&',
		buttonText: '@'
	},

	controller: class ReportsPageTemplateComponent {
		constructor(ApiService, $parse) {
			'ngInject';

			this.apiService = ApiService;
			this.$parse = $parse;
		}

		$onInit() {
			this.buttonText = this.buttonText || 'View Report';
			this._isArchiveOptionEnabled = this.$parse(this.isArchiveOptionEnabled || 'false')(false);
			this._displayTitle = this.$parse(this.displayTitle || 'false')(false);
		}

		_onPageChange(pageNumber) {
			return this.onPageChange({
				$event: pageNumber
			});
		}

		_getFileName(report) {
			const pdf = report.pdf;
			return pdf ? this.apiService.getResourceUrl(`files/pdf/${pdf}`) : report.url;
		}

		_getImage(report) {
			const image = report.image;
			return image ? this.apiService.getResourceUrl(`files/images/${image}`) : '';
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/common/components/reports-page-template/reports-page-template.component.js